import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  menuContainer: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${(theme.palette as any).border?.main ?? theme.palette.divider}`,
    borderRadius: '10px',
    minWidth: '246px',
    maxHeight: '500px',
    overflowY: 'auto',
    lineHeight: '1',
    boxShadow: '0 4px 8px 0 rgba(19, 15, 38, 0.08)',

    [theme.breakpoints.down('md')]: {
      width: '100dvw',
      height: MAX_PAGE_HEIGHT,
      top: 0,
      bottom: 'auto !important',
      left: '0 !important',
      right: 'unset !important',
      maxWidth: 'unset !important',
      borderRadius: '10px 10px 0 0 !important',
    },

    '& > ul': {
      padding: '0',

      '& svg': {
        color: theme.palette.text.secondary,
      },
    },
  },

  menuBackground: {
    [theme.breakpoints.down('md')]: {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
    },
  },

  alignTop: {
    [theme.breakpoints.down('md')]: {
      bottom: 'unset !important',
      top: 'calc(70px + env(safe-area-inset-top, 0px) + var(--vv-offset-top, 0px)) !important',
      borderRadius: '0px 0px 10px 10px !important',
    },
  },
}));
